// import { Logger } from "aws-amplify"
import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber"
import _ from "lodash"

// ---- SSR-safe logger factory ----
type LoggerLike = {
  debug: (...a: any[]) => void
  info: (...a: any[]) => void
  warn: (...a: any[]) => void
  error: (...a: any[]) => void
}

function createLogger(name: string): LoggerLike {
  if (typeof window !== "undefined") {
    // Only require aws-amplify in the browser (avoids SSR constructor issues)
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { Logger } = require("aws-amplify")
    return new Logger(name)
  }
  // Server: noop/console logger so SSR never crashes
  return {
    debug: () => {},
    info: () => {},
    warn: () => {},
    error: () => {},
  }
}
// ---------------------------------

const phoneUtil = PhoneNumberUtil.getInstance()
const logger = createLogger("phone-number")

export const toNationalPhoneNumber = (
  phoneNumber: string,
  regionCode = "ZA",
): string | null => {
  if (_.isEmpty(phoneNumber)) {
    return null
  }

  let nationalPhoneNumber = phoneNumber
  try {
    const number = phoneUtil.parseAndKeepRawInput(phoneNumber, regionCode)
    nationalPhoneNumber = phoneUtil.format(number, PhoneNumberFormat.NATIONAL)
  } catch (err) {
    logger.error(err)
  }
  return nationalPhoneNumber
}

export const toInternationalPhoneNumber = (
  phoneNumber: string,
  regionCode = "ZA",
): string | null => {
  if (_.isEmpty(phoneNumber)) {
    return null
  }

  let nationalPhoneNumber = phoneNumber
  try {
    const number = phoneUtil.parseAndKeepRawInput(phoneNumber, regionCode)
    nationalPhoneNumber = phoneUtil.format(number, PhoneNumberFormat.E164)
  } catch (err) {
    logger.error(err)
  }
  return nationalPhoneNumber
}

export const validatePhoneNumber = (
  phoneNumber: string | null | undefined,
  regionCode = "ZA",
): boolean => {
  if (!phoneNumber || _.isEmpty(phoneNumber)) {
    return false
  }

  try {
    const number = phoneUtil.parseAndKeepRawInput(phoneNumber, regionCode)
    return phoneUtil.isValidNumber(number)
  } catch (err) {
    logger.error(err)
    return false
  }
}
